// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Link-module--cds--assistive-text--ryfUS";
export var cdsVisuallyHidden = "Link-module--cds--visually-hidden--tCd4z";
export var hideFeedback = "Link-module--hide-feedback--LEYMY";
export var link = "Link-module--link--Boesv";
export var showFeedback = "Link-module--show-feedback--vfyJY";
export var skeleton = "Link-module--skeleton--liy5h";